// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteTemplates_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/site_templates/salvar (staff, Full).
 * `id` absent = create. Address lists are comma-separated text, as typed.
 *
 * Validation is strict about the two things a broken template costs silently:
 * a slug the site will never ask for, and an address the mailer will never
 * reach. Both would look like a saved template and send nothing.
 */
import { registerContract } from './validate'

export interface SiteTemplates_SalvarInput {
formulario: string
assunto: string
corpo: string
destinatarios: string
id?: number
copias?: string
ativo?: boolean
}

registerContract('SiteTemplates_SalvarInput', {
  formulario:    { type: 'string',  required: true },
  assunto:       { type: 'string',  required: true },
  corpo:         { type: 'string',  required: true },
  destinatarios: { type: 'string',  required: true },
  id:            { type: 'number',  required: false },
  copias:        { type: 'string',  required: false },
  ativo:         { type: 'boolean', required: false },
})
